import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Grid';
import AppLink from '../../../../components/AppLink';
import RelicAvatar from '../../../../components/RelicAvatar';
// import {} from 'loadash'
import { blue, } from '@mui/material/colors';

import { Patient } from '../../../../models';
import { titleCase } from '../../../../helpers';

const PatientView: React.FC<{
    patient: Patient;
    show: boolean;

}> = ({
    patient,
    show

}) => {

        return (
            <Box sx={{

                minWidth: '250px'
            }}>
                <Box display="flex" sx={{ mb: 2 }}>
                    <RelicAvatar size={60} avatarBgColor={blue[500]} user={patient} display />

                    <div style={{ paddingLeft: '1em' }}>
                        <Typography fontWeight={'bold'} sx={{
                            mr: 1
                        }}>
                            {titleCase(`${patient.FirstName} ${patient.LastName}`)}
                        </Typography>

                        <Typography color="inherit" fontSize={'14px'} fontWeight={400}>
                            {patient.Email}
                        </Typography>

                        {show && (<AppLink to={"/patients/view/" + patient.id} >
                            View
                        </AppLink>)}
                    </div>
                </Box>

                <div style={{
                    padding: '1em',
                    borderRadius: '24px',
                    border: '1px solid rgba(107, 119, 154, 0.1)'
                }}>
                    <Typography component="h6" variant="h6" fontWeight={'bold'}>
                        User Info
                    </Typography>
                    <Grid container spacing={1} style={{
                        marginBottom: '12px'
                    }}>
                        <Grid item xs={4} >
                            <div className="name-item">
                                <Typography variant='subtitle1'>
                                    Gender
                                </Typography>
                                <Typography fontWeight={'bold'}>
                                    {patient.Sex}
                                </Typography>
                            </div>
                        </Grid>

                        <Grid item xs={4} >
                            <div className="name-item">
                                <Typography variant='subtitle1'>
                                    Age
                                </Typography>
                                <Typography fontWeight={'bold'}>
                                    25 years
                                </Typography>
                            </div>
                        </Grid>

                        <Grid item xs={4} >
                            <div className="name-item">
                                <Typography variant='subtitle1'>
                                    Discipline
                                </Typography>
                                <Typography fontWeight={'bold'}>
                                    Patient
                                </Typography>
                            </div>
                        </Grid>




                    </Grid>


                </div>

            </Box>
        )
    }

export default PatientView